export const SUCCESS_IMAGE_CATEGORY_LIST = "SUCCESS_IMAGE_CATEGORY_LIST";
export const LOADING_IMAGE_CATEGORY_LIST = "LOADING_IMAGE_CATEGORY_LIST";
